import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

type Lookup = {
    id: number
    name_th: string
    name_en: string
}

const useUserGroup = () => {
    const callApi = useCallApi()
    const [userGroup, setUserGroup] = useState<Lookup[]>([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet({
                url: umServinceURL.getLookupUserGroup,
            })
            setUserGroup(data.result as Lookup[])
        } catch (error) {
            console.log('error', error)
        }
    }

    return { userGroup }
}

export default useUserGroup
